
const heroHighlights = [
	"Since 2025",
	"Jawa Timur, Indonesia",
	"Platform IELTS #1",
	"Instructor Bersertifikasi",
];

const Hero = () => {
	return (
		<section className="st-aboutus-hero flex min-h-[calc(100vh-80px)] flex-col px-4 pb-0 pt-0">
			<div className="mx-auto flex w-full max-w-7xl flex-1 items-center">
				<div className="flex w-full flex-col items-center text-center">
					<span className="st-aboutus-hero-kicker inline-flex items-center rounded-full px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.16em] sm:text-[12px]">
						TENTANG SCHOLARSTODAY
					</span>

					<h1 className="st-aboutus-hero-title st-font-display mt-7 max-w-[1060px] text-[40px] leading-[0.98] tracking-[-0.04em] sm:text-[52px] md:text-[60px] lg:text-[72px]">
						<span className="block">
							Setiap tahun, <span className="st-aboutus-hero-emphasis font-bold italic">ribuan</span> orang <span className="st-aboutus-hero-emphasis italic">gagal</span> lolos
						</span>
						<span className="block">
							beasiswa <span className="st-aboutus-hero-emphasis font-bold italic">bukan</span> karena kurang <span className="st-aboutus-hero-emphasis italic">pintar</span>
						</span>
						<span className="block">
							tapi karena <span className="st-aboutus-hero-emphasis italic">skor</span> <span className="st-aboutus-hero-emphasis font-bold italic"> IELTS</span> <span className="st-aboutus-hero-emphasis italic">kurang satu</span> poin
							<span className="st-aboutus-hero-accent">.</span>
						</span>
					</h1>

					<p className="st-aboutus-hero-body st-font-body mt-8 max-w-[760px] text-[15px] leading-[1.7] sm:text-[16px] lg:text-[18px]">
						ScholarsToday lahir untuk menutup gap itu. Didirikan di Kampung Inggris, Pare — dengan satu tujuan yang jelas.
					</p>

					<div className="mt-8 flex flex-wrap justify-center gap-3 sm:mt-10">
						{heroHighlights.map((highlight) => (
							<span
								key={highlight}
								className="st-aboutus-hero-chip st-font-body inline-flex items-center gap-2 rounded-full px-4 py-2 text-[12px] font-medium sm:text-[13px]"
							>
								<span className="st-aboutus-hero-chip-dot h-2 w-2 rounded-full" />
								{highlight}
							</span>
						))}
					</div>
				</div>
			</div>

			<div className="st-aboutus-hero-ribbon mt-12 -mx-4 overflow-hidden px-4 py-4 sm:mt-16 sm:-mx-4 sm:px-6 sm:py-5 lg:mt-18 lg:px-8">
				<div className="mx-auto w-full max-w-7xl overflow-hidden">
					<div className="st-aboutus-hero-ribbon-text whitespace-nowrap text-center text-[11px] font-bold uppercase tracking-[0.24em] sm:text-[12px] lg:text-[14px]">
						<span className="st-aboutus-hero-ribbon-separator inline-block align-middle">✦</span>
						<span className="inline-block px-8 align-middle">Didirikan 2025</span>
						<span className="st-aboutus-hero-ribbon-separator inline-block align-middle">✦</span>
						<span className="inline-block px-8 align-middle">500 Alumni sukses</span>
						<span className="st-aboutus-hero-ribbon-separator inline-block align-middle">✦</span>
						<span className="inline-block px-8 align-middle">IELTS Certified Instructors</span>
						<span className="st-aboutus-hero-ribbon-separator inline-block align-middle">✦</span>
						<span className="inline-block px-8 align-middle">Metode terstruktur</span>
						<span className="st-aboutus-hero-ribbon-separator inline-block align-middle">✦</span>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Hero;
